module.exports = __webpack_public_path__ + "img/20.b3be5059.jpg";